import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { authService } from "Service/Axios";
import { FORM_BUILDER_FORM_MULTIPLE_EDIT_URL } from "Constant/api";
import { Validator } from "Utils/validator";

export const SaveFormTemplate = ({
  show,
  toggle,
  selectedFormIds,
  fetchFormList,
}) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    templateName: "",
  });
  const [errMsg, setErrMsg] = useState({
    templateName: "",
  });

  const { templateName } = formData;

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (e.target.name === "roleName") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          templateName: t(
            "common.messages.error.email.template.templateName.blank"
          ),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          templateName: "",
        }));
      }
    }
  };

  // Validation
  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(templateName)) {
        resolve(true);
      } else {
        if (!Validator.text(templateName)) {
          setErrMsg((prev) => ({
            ...prev,
            templateName: t(
              "common.messages.error.email.template.templateName.blank"
            ),
          }));
        }

        resolve(false);
      }
    });
  };

  // On Submit
  const onSaveAsTemplateForm = async () => {
    const validationStatus = await getValidation();
    if (validationStatus)
      try {
        const payload = {
          ids: selectedFormIds,
          type: "SaveAsTemplate",
          templateName: templateName,
          template: true,
        };
        await authService(FORM_BUILDER_FORM_MULTIPLE_EDIT_URL, "POST", payload);
        toggle();
        fetchFormList();
        toast.success(
          t("common.messages.notification.success.bulkSaveAsTemplateForm", {
            count: selectedFormIds.length,
          })
        );
      } catch (error) {
        if (error.response && error.response.data) {
          toast.error(error.response.data.message);
        }
      }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>{t("auth.formBuilder.saveAsTemplate")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="templateName">{t("common.label.template")}</label>
          <input
            type="text"
            className="form-control"
            id="templateName"
            placeholder={t("common.placeHolder.emailTemplateName")}
            name="templateName"
            value={templateName}
            onChange={handleChange}
          />
          {errMsg.templateName && (
            <p className="error">{errMsg.templateName}</p>
          )}
        </div>
        {/* <div className="template-category">
          <span className="category-title me-2">Template Category :</span>
          <span className="badge-category">Admission Form</span>
          <span className="badge-category">Event & Visions</span>
          <span className="badge-category">Fundraiser</span>
          <span className="badge-category">Interview</span>
          <span className="badge-category">Scholarship</span>
          <span>
            <input
              type="text"
              className="border-0 bg-transparent"
              placeholder="Type Category"
            />
          </span>
        </div> */}
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button variant="outline-primary" onClick={toggle}>
          {t("common.button.cancel")}
        </Button>
        <Button variant="primary" onClick={onSaveAsTemplateForm}>
          {t("common.button.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
